import React from 'react';

function App() {
  return (
      <div className="flex justify-center items-center h-screen">
        <h2 class="text-5xl sm:text-6xl text-left sm:text-center font-extrabold tracking-tight text-gray-900 mb-4">
          <span className="block tracking-tighter">KrakenVPN</span>
          <span className="uppercase tracking-widest font-normal block text-sm text-left text-gray-500">
          Fast | Secure | Open-source
        </span>
        </h2>
      </div>
  )
}

export default App;
